import axios from "axios";
import Config from "../../../config/index";

import {
  GET_PICKLIST_DOWNLOAD_FAILURE,
  GET_PICKLIST_DOWNLOAD_REQUEST,
  GET_PICKLIST_DOWNLOAD_SUCCESS,
  GET_PICKLIST_REPORT_FAILURE,
  GET_PICKLIST_REPORT_REQUEST,
  GET_PICKLIST_REPORT_SUCCESS,
} from "./picklistTrackingReportTypes";
let baseUrl = Config.baseUrl;
let baseUrlReport = Config.baseUrlReport;

const getPicklistTrackingReportRequest = () => {
  return {
    type: GET_PICKLIST_REPORT_REQUEST,
  };
};

const getPicklistTrackingReportSuccess = (payload) => {
  return {
    type: GET_PICKLIST_REPORT_SUCCESS,
    payload: payload,
  };
};

const getPicklistTrackingReportFailure = (error) => {
  return {
    type: GET_PICKLIST_REPORT_FAILURE,
    payload: error,
  };
};

const getPicklistTrackingReport = (pageNo, rowsPerPage, search, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(getPicklistTrackingReportRequest());
    let url = `${baseUrlReport}/picklist_tracking?download=0&page_number=${
      pageNo + 1
    }&rows_per_page=${rowsPerPage}&search=${search ? search : ""}&startDate=""&endDate=""`;
    axios
      .get(url, headers)
      .then((response) => {
        dispatch(getPicklistTrackingReportSuccess(response.data));
      })
      .catch((err) => {
        dispatch(getPicklistTrackingReportFailure(err.response));
      });
  };
};

const downloadPicklistTrackingReportRequest = () => {
  return {
    type: GET_PICKLIST_DOWNLOAD_REQUEST,
  };
};

const downloadPicklistTrackingReportSuccess = (payload) => {
  return {
    type: GET_PICKLIST_DOWNLOAD_SUCCESS,
    payload: payload,
  };
};

const downloadPicklistTrackingReportFailure = (error) => {
  return {
    type: GET_PICKLIST_DOWNLOAD_FAILURE,
    payload: error,
  };
};

const downloadPicklistTrackingReport = (
  startDate,
  endDate,
  search,
  jwtToken
) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(downloadPicklistTrackingReportRequest());
    let url = `${baseUrlReport}/picklistreport_download?start_cd=${endDate}&end_cd=${startDate}&search=${search ? search : ""}`;
    axios
      .get(url, headers)
      .then((response) => {
        dispatch(downloadPicklistTrackingReportSuccess(response.data));
      })
      .catch((err) => {
        dispatch(downloadPicklistTrackingReportFailure(err.response));
      });
  };
};

export { getPicklistTrackingReport, downloadPicklistTrackingReport };
